// extracted by mini-css-extract-plugin
export default {"container":"B4jkMA6bIxt2ZLiqfDBQ","row":"IYnIr7Fq1nKLhH946J7L","column":"UiPnn9IZa83_rn0nfWcH"};